import React from 'react';
import './LogoutPopup.css';

export default function LogoutPopup({
  logoutError,
  onCancel,
  onLogout,
  activeForm,
}) {
  return (
    <>
      <div
        onClick={onCancel}
        className={`overlay ${activeForm === 'exit' ? 'show' : 'hide'}`}
      ></div>
      <div
        style={{
          transform:
            activeForm === 'exit'
              ? 'translate(-50%, -50%)'
              : 'translate(80vw, -50%)',
        }}
        className='auth-forms__form auth-forms__form_logout'
      >
        <h2 className='auth-forms__title'>Выйти</h2>
        {logoutError && (
          <p className='auth-forms__error-message auth-forms__error-message_logout'>
            {logoutError}
          </p>
        )}
        <div className='auth-forms__form-container-logout'>
          <button onClick={onLogout} className='auth-forms__button'>
            Выйти
          </button>
          <button
            onClick={onCancel}
            className='auth-forms__button'
            style={{ background: 'black' }}
          >
            Отмена
          </button>
        </div>
      </div>
    </>
  );
}
